const styles = (theme) => ({
  title: { fontWeight: "bold", fontSize: "20px" },
  containerHeader: {
    p: 1,
  },
  paperBody: {
    p: 2,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  loading: { display: "flex", justifyContent: "center", p: 4 },
  headerBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 0.5,
  },
  subtitle: {
    fontSize: "13px",
    color: "text.secondary",
    lineHeight: 1.4,
  },
  atualBox: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
  },
  atualLabel: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  atualValor: {
    fontSize: "0.85rem",
    fontWeight: 600,
  },
  alert: {
    borderRadius: "12px",
  },
  autocomplete: {
    width: "100%",
    maxWidth: 600,
  },
  checkbox: { mr: 1 },
  boxActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    mt: 2,
  },
  boxEditActions: {
    display: "flex",
    gap: 1,
  },
});
export default styles;
